import { Bell, Clock, Mail } from "lucide-react";
import { formatCurrency } from "./jobConstants";

const JobApprovalModal = ({ isOpen, job, eligibleUsers, loadingCount, onApproveWithNotify, onApproveWithoutNotify, onClose }) => {
  if (!isOpen || !job) return null;

  const stop = (e) => e.stopPropagation();

  return (
    <div className="sz-modal-backdrop" style={{ zIndex: 200 }} onClick={onClose}>
      <div className="sz-modal-card w-full max-w-[430px] overflow-hidden" onClick={stop}>
        {/* Gradient header */}
        <div className="sz-modal-header-grad p-[22px_24px]">
          <div className="flex items-center gap-[11px]">
            <div className="w-[38px] h-[38px] rounded-[11px] flex items-center justify-center" style={{ background: "rgba(255,255,255,.18)" }}>
              <Bell className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="sz-h3 text-white" style={{ fontSize: 17 }}>Approve job?</h3>
              <div className="text-[12.5px] mt-0.5" style={{ color: "rgba(255,255,255,.8)" }}>
                {job.title} · {formatCurrency(job.budget || job.total_amount || 0)}
              </div>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="p-[18px_20px]">
          <div className="flex items-center gap-2 px-[13px] py-2.5 rounded-[11px] mb-3.5 text-[12.5px] text-[#2B3142]" style={{ background: "#F1F3F7" }}>
            {loadingCount ? (
              <>
                <Clock className="w-[15px] h-[15px] animate-spin text-[#572B7C]" />
                Counting eligible crew…
              </>
            ) : (
              <>
                <Mail className="w-[15px] h-[15px] text-[#572B7C] shrink-0" />
                <span>Notifies <strong>{eligibleUsers} eligible crew member{eligibleUsers !== 1 ? "s" : ""}</strong> by email &amp; push.</span>
              </>
            )}
          </div>

          <button
            onClick={onApproveWithNotify}
            className="sz-btn sz-btn-primary w-full mb-[9px] py-[13px] text-[13.5px]"
          >
            Approve &amp; Notify ({eligibleUsers})
          </button>
          <button
            onClick={onApproveWithoutNotify}
            className="sz-btn sz-btn-outline w-full mb-[9px] py-3 text-[13px]"
          >
            Approve Silently
          </button>
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-[12px] bg-transparent text-[13px] font-semibold text-[#8A90A2]"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobApprovalModal;
